<template>
  <v-container fluid pa-0>
    <a-search :title="$t('currencies')" icon="monetization_on" />
    <v-layout row wrap justify-center style="margin-top: -65px">
      <v-card class="flex xs11">
        <form-dialog
          v-model="dialog"
          :title="currency.id ? $t('edit_record') : $t('new_record')"
        >
          <new-currency v-model="currency" @saved="save" />
        </form-dialog>
        <v-toolbar color="grey6 elevation-0">
          <v-btn color="primary" @click="dialog = true" v-if="can.add">{{
            $t("new_record")
          }}</v-btn>
          <v-spacer />
        </v-toolbar>
        <v-card-text>
          <v-flex xs12>
            <draggable
              v-model="items"
              :options="options"
              class="layout row wrap"
              @change="onMove"
            >
              <div
                class="item flex xs12 flex-row border"
                v-for="(item, index) in items"
                :key="item.id"
              >
                <v-icon icon color="grey lighten-1" class="draggable"
                  >drag_indicator</v-icon
                >
                <span class="pa-2">{{ item.name }} ( {{ item.fa_name }} )</span>
                <v-spacer />
                <v-btn
                  flat
                  icon
                  small
                  v-if="can.edit"
                  color="grey darken-1"
                  @click="editItem(item, index)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  small
                  icon
                  class="ma-0"
                  v-if="can.delete"
                  color="grey darken-1"
                  @click="deleteItem(item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </div>
            </draggable>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template> 

<script>
import draggable from "vuedraggable";
import newCurrency from "./newCurrency.vue";
import { customersMixin } from "@/mixins/index.js";

export default {
  mixins: [customersMixin],
  components: { newCurrency, draggable },
  data() {
    return {
      items: [],
      dialog: false,
      editedIndex: -1,
      loading: true,

      currency: {
        name: "",
        rank: "",
      },
      options: {
        animation: 200,
        handle: ".draggable",
        chosenClass: "grey5", // Class name for the chosen item
      },
    };
  },
  computed: {
    can() {
      return {
        add: this.userCan("add_currencies"),
        view: this.userCan("view_currencies"),
        edit: this.userCan("edit_currencies"),
        delete: this.userCan("delete_currencies"),
        any:
          this.userCan("edit_currencies") ||
          this.userCan("view_currencies") ||
          this.userCan("delete_currencies"),
      };
    },
    headers: (vm) => {
      let items = [
        {
          text: vm.$t("currency"),
          sortable: false,
          value: "currency",
        },
        {
          text: vm.$t("currency_worth"),
          sortable: false,
          value: "rank",
        },
        {
          text: vm.$t("actions"),
          sortable: false,
          value: "actions",
        },
      ];
      if (vm.can.any)
        items.push({
          sortable: false,
          value: "actions",
          text: vm.$t("actions"),
        });
      return items;
    },
  },
  methods: {
    initData() {
      this.loading = true;
      this.axios
        .get(`currencies`)
        .then((resp) => {
          this.items = resp.data.data;
          this.currency.rank = this.items.length + 1;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    editItem(item, index) {
      this.currency = { ...item };
      this.editedIndex = index;
      this.dialog = true;
    },
    deleteItem(item) {
      let vm = this;
      const index = this.items.indexOf(item);
      this.$alert("currencies/" + item.id).then(() => {
        vm.initData();
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.currency.id = null;
        this.editedIndex = -1;
      }, 300);
    },

    save(item) {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], item);
      } else {
        this.items.push(item);
      }
      this.close();
    },
    onMove(evt) {
      this.items.map((item, index) => {
        item.rank = index + 1;
      });
      this.axios.put("/currencies", { items: this.items }).then(() => {
        this.getCustomers();
        //reload currencies
      });
    },
  },
  created() {
    this.initData();
  },
};
</script>
<style>
.lable-out _less {
  right: -16px;
  position: relative;
  min-width: 100px;
  text-align: center;
}
.draggable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.draggable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
</style>
